import Vue from 'vue/dist/vue.runtime.esm';
import './Config';
import Routes from './Routes';
import Main from './main.vue';

import XAjax from '@ul/ajax';
Date.prototype.Format = function(fmt){ //author: meizz
    const o = {
        "M+" : this.getMonth()+1,                 //月份
        "d+" : this.getDate(),                    //日
        "h+" : this.getHours(),                   //小时
        "m+" : this.getMinutes(),                 //分
        "s+" : this.getSeconds(),                 //秒
        "q+" : Math.floor((this.getMonth()+3)/3), //季度
        "S"  : this.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(let k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
};
let isMobile=false

const vue = new Vue({
    el: '#app',
    router: Routes,
    render: (h) => h(Main),
    data: {
        isMobile,
    },
    mounted() {
        // this.$store.dispatch(ActionType.GET_PRTYPECODE);
    },
    methods: {
        $navName(name, data) {
            let nvObj = { name };
            if (!name) {
                this.$router.back();
                return;
            }
            if (data && typeof data !== 'object') return;
            this.$router.push({ name, params: { data } });
        },
    },
});
